import { IOrganization } from '@boma/administration-portal/shared/entities';
import { IProfile } from '@boma/supplier-portal/shared/entities';
import { createAction, props } from '@ngrx/store';

export const loadUser = createAction('[User] Load User');

export const loadUserSuccess = createAction(
  '[User] Load User Success',
  props<{ payload: IProfile }>()
);

export const loadUserFailure = createAction(
  '[User] Load User Failure',
  props<{ error: any }>()
);

export const setSelectedSupplier = createAction(
  '[User] Set Selected Supplier',
  props<{ id: string }>()
);

export const getEntityDetails = createAction(
  '[User] Get Entity Details',
  props<{ id: string }>()
);

export const loadEntitySuccess = createAction(
  '[User] Load Entity Success',
  props<{ payload: IOrganization }>()
);
